export default {
  USERS: "users", // user information
  USER_TOKEN: "token", // jwt token
  SITE_HISTORY: "siteList", // site name history list
  LOCAL_VIEWS: "views" // webconnect local views
};



// WEBPACK FOOTER //
// ./src/consts/storageKeys.js